export enum CustomerType {
     NOTSure = -2,
     NA = -1,
     AH = 1,
     ISP = 6,
}
